<script>
  import { status } from "./status.js";
  import { onMount } from "svelte";
  import { tl } from "./multilang.js";
  import { slide, fade } from 'svelte/transition';
  import {
    getUsers,
    enrollUser,
    getUserStatus,
    statusChange,
    deleteUser,
    getOfflineChallenge,
    sendOfflineResponse
  } from "./apihandler.js";
  import page from "page";

  import { fancyAlert, fancyConfirm, fancyMessage } from "./notification.js";

  import {copyTextToClipboard} from "./copyTextToClipboard.js";

  // User creation and enrollment

  function createUserModal() {
    qrContent = "";
    deeplink = "";
    newUserName = "";
    newUserServiceIndex = 0;
    createUserModalFlag = true;
    creationDone = false;
  }

  function createUser() {
    let id = newUserName;
    let service = `${$status.subscription.id}_${$status.subscription.services[newUserServiceIndex].name}`;
    let authKey =
      $status.subscription.services[newUserServiceIndex].adminAuthKey;

    enrollUser(id, service, authKey, false)
      .then(enrollData => {
        qrContent = enrollData.qrCode;
        deeplink = enrollData.dl;
        $status.subscription.users.push({
          user: newUserName,
          service: $status.subscription.services[newUserServiceIndex].name,
          status: 0,
          enrollmentData: { qr: qrContent, dl: deeplink }
        });
        $status.subscription.currentUsers++;
        $status = $status;
        creationDone = true;
      })
      .catch(async error => {
        await fancyAlert(error, tl("Error"));
      });
  }

  function reEnrollUser() {
    let id = $status.subscription.users[userIndex].user;
    let service = `${$status.subscription.id}_${
      $status.subscription.services.find(
        i => i.name == $status.subscription.users[userIndex].service
      ).name
    }`;
    let authKey = $status.subscription.services.find(
      i => i.name == $status.subscription.users[userIndex].service
    ).adminAuthKey;

    enrollUser(id, service, authKey, true)
      .then(enrollData => {
        $status.subscription.users[userIndex].enrollmentData.qr =
          enrollData.qrCode;
        $status.subscription.users[userIndex].enrollmentData.dl = enrollData.dl;
        $status.subscription.users[userIndex].status = 0;
      })
      .catch(async error => {
        await fancyAlert(error, tl("Error"));
      });
  }

  // User removal

  function removeUser(index) {
    let id = $status.subscription.users[index].user;
    let service = `${$status.subscription.id}_${$status.subscription.users[index].service}`;
    let authKey = $status.subscription.services.find(
      i => i.name == $status.subscription.users[index].service
    ).adminAuthKey;

    deleteUser(id, service, authKey)
      .then(() => {
        $status.subscription.users.splice(index, 1);
        $status.subscription.currentUsers--;
        $status = $status;
      })
      .catch(async error => {
        await fancyAlert(error, tl("Error"));
      });
  }

  // User status

  function refreshUserStatus(index) {
    let id = $status.subscription.users[index].user;
    let service = `${$status.subscription.id}_${$status.subscription.users[index].service}`;
    let authKey = $status.subscription.services.find(
      i => i.name == $status.subscription.users[index].service
    ).adminAuthKey;

    getUserStatus(id, service, authKey)
      .then(newStatus => {
        $status.subscription.users[index].status = newStatus;
      })
      .catch(async error => {
        await fancyAlert(error, tl("Error"));
      });
  }

  function refreshUsers() {
    let id = $status.subscription.id;
    let code = $status.subscription.sessionAuth;

    getUsers(id, code)
      .then(userData => {
        $status.subscription.currentUsers = userData.currentUsers;
        $status.subscription.users = userData.users;
        for (let i = 0; i < userData.currentUsers; i++)
          $status.subscription.users[i].status = 5;
        for (let i = 0; i < userData.currentUsers; i++) refreshUserStatus(i);
      })
      .catch(async error => {
        if (error == 403) {
          await fancyAlert(tl("Your session expired, please log in again"), tl("Session expired"));
          page("/login");
          $status.loggedIn = false;
          $status.subscription = {};
        } else {
          await fancyAlert(error, tl("Error"));
        }
      });
  }

  function refreshUserStatusModal(index) {
    adminUserModal(index); 
    fancyMessage(tl("Status refreshed"));
  }

  async function adminUserModal(index) {
    userIndex = index;
    refreshUserStatus(index);
    adminUserModalFlag = true;
  }

  function changeUserStatus(changeStatus) {
    let id = $status.subscription.users[userIndex].user;
    let service = `${$status.subscription.id}_${$status.subscription.users[userIndex].service}`;
    let authKey = $status.subscription.services.find(
      i => i.name == $status.subscription.users[userIndex].service
    ).adminAuthKey;

    statusChange(id, service, authKey, changeStatus)
      .then(() => {
        $status.subscription.users[userIndex].status = changeStatus;
      })
      .catch(async error => {
        await fancyAlert(error, tl("Error"));
      });
  }

  function offlineModeModal(index) {
    userIndex = index;
    userChallenge = "";
    userResponse = "";
    offlineModeModalFlag = true;
  }

  function offlineModeChallenge() {
    let id = $status.subscription.users[userIndex].user;
    let service = `${$status.subscription.id}_${$status.subscription.users[userIndex].service}`;
    let authKey = $status.subscription.services.find(
      i => i.name == $status.subscription.users[userIndex].service
    ).adminAuthKey;

    getOfflineChallenge(id, service, authKey, +challengeSize)
    .then((challenge) => {
      userChallenge = challenge;
    })
    .catch(async (error) => {
      if (error == 403) {
        await fancyAlert(tl("The ZofToken to test needs to be in the closed status"), tl("Error"));
      }
      else {
        await fancyAlert(error, "Error");
      }
    });
  }

  function offlineModeResponse() {
    let id = $status.subscription.users[userIndex].user;
    let service = `${$status.subscription.id}_${$status.subscription.users[userIndex].service}`;
    let authKey = $status.subscription.services.find(
      i => i.name == $status.subscription.users[userIndex].service
    ).adminAuthKey;

    sendOfflineResponse(id, service, authKey, userResponse.toUpperCase())
    .then(async (statusChange) => {
      if (statusChange == 1) {
        await fancyAlert(tl("Token successfully open"), tl("Notification"), tl("OK"), "NORMAL");
        $status.subscription.users[userIndex].status = 1;
        offlineModeModalFlag = false;
      }
      else {
        await fancyAlert(tl("User opened the token under duress"));
        $status.subscription.users[userIndex].status = 3;
        offlineModeModalFlag = false;
      };
    })
    .catch(async (error) => {
      if (error == 403) {
        await fancyAlert(tl("Invalid response or user blocked"), tl("Error"));
      }
      else {
        await fancyAlert(error, tl("Error"));
      }
    });
  }

  function copyToClipboard(text) {

    if (copyTextToClipboard(text)) {
      fancyMessage(tl("Copy succesful")); 
    }
  }

  function copyToClipboardNotDisabled(text) {
    if (text) {
      copyToClipboard(text);
    }
  }

  // Component variables

  let createUserModalFlag = false;
  let adminUserModalFlag = false;
  let offlineModeModalFlag = false;
  let userFilter, serviceFilter;
  let userIndex = 0;
  let newUserName = "";
  let newUserServiceIndex = 0;
  let qrContent = "";
  let deeplink = "";
  let creationDone = false;
  let userChallenge = "";
  let userResponse = "";
  let challengeSize = 4;
  
  // Mount configuration

  onMount(async () => {

    $status.notification.show = false;
    $status.notification.confirm = false;

    refreshUsers();

    if ($status.params) {
      // Add a filter when coming from the service page button
      serviceFilter = $status.params;
      $status.params = "";
    }
  });

</script>

<style>
h4 {
  padding-right: 1rem;
}

.is-clickable > input[disabled] {
  cursor: pointer;
}

.monotype{
  font-family: 'Fira Code';
}

.a-copy{
  padding-left: 2.2rem;
  background-repeat: no-repeat;
  background-image: url(../assets/icon-copy.svg);
  background-position: left top 7px;
}

</style>

<svelte:head>
  <title>ZaaS - {tl("My users")}</title>
</svelte:head>


<section class=" has-background-grey-lightest	">
  <div class="container">

    <div class="columns is-centered">
      <div class="column">

        <div class="level">
          <div class="level-left">
            <div class="level-item is-baseline">
              <h4 class="is-size-4">{tl("My users")}</h4>
              <span class="is-size-7">
                {tl("Your subscription has")}
                <strong>{$status.subscription.currentUsers}</strong>
                {$status.subscription.maxUsers ? `/ ${$status.subscription.maxUsers}` : ""} {tl("users")}
              </span>
            </div>
          </div>

          <div class="level-right">

            <div class="level-item">
              <div class="field has-addons">
                <div class="control has-icons-right">
                  <input
                    class="input"
                    bind:value={userFilter}
                    placeholder={tl("Search for a user")} on:click={() => (userFilter = '')} />
                                                        <span class="icon is-small is-right">
                                        <ion-icon name="{userFilter ? 'close-circle-outline' : 'search-outline'}" ></ion-icon>
                                    </span>
                </div>
                <!-- <div class="control">
                  <div
                    class="icon is-medium"
                    on:click={() => (userFilter = '')}>
                    <ion-icon name="{userFilter ? 'close-circle-outline' : 'search-outline'}" ></ion-icon>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="level-item">
              <div class="field has-addons">
                <div class="control has-icons-right">
                  <input
                    class="input"
                    bind:value={serviceFilter}
                    placeholder={tl("Search for a service")} on:click={() => (serviceFilter = '')} />
                                                                            <span class="icon is-small is-right" >
                                        <ion-icon name="{serviceFilter ? 'close-circle-outline' : 'search-outline'}" ></ion-icon>
                                    </span>
                </div>
                <!-- <div class="control">
                  <div
                    class="icon is-medium"
                    on:click={() => (serviceFilter = '')}>
                    <ion-icon name="{serviceFilter ? 'close-circle-outline' : 'search-outline'}" ></ion-icon>
                  </div>
                </div> -->
              </div>
            </div>

            <div class="level-item">
              <button
                class="button is-dark"
                on:click={createUserModal}
                disabled={$status.subscription.maxUsers && $status.subscription.currentUsers >= $status.subscription.maxUsers}>
                {tl("New user")}
              </button>
            </div>
          </div>
        </div>

        {#if $status.subscription.users.length}
          <div class="columns is-centered">
            <div class="column">

              <table class="table is-hoverable is-fullwidth is-outlined">

                <thead class="has-text-grey-light">
                  <tr>
                    <th>{tl("User name")}</th>
                    <th>{tl("Service")}</th>
                    <th>
                        <!-- align these -->
                              {tl("Status")}
                            <span class="icon is-large is-clickable zt-icon-in-th" on:click={refreshUsers}>
                              <ion-icon name="refresh-circle"></ion-icon>
                            </span>
                        </th>
                    <th />
                  </tr>
                </thead>

                <tbody>
                  {#each $status.subscription.users.filter(i => (!userFilter || i.user
                          .toLowerCase()
                          .includes(
                            userFilter.toLowerCase()
                          )) && (!serviceFilter || i.service
                          .toLowerCase()
                          .includes(serviceFilter.toLowerCase()))) as user}
                    <tr>
                      <td>{user.user}</td>
                      <td>{user.service}</td>
                      <td>
                        {#if user.status == 0}
                          <span class="tag is-small is-warning">{tl("Awaiting enrollment")}</span>
                        {/if}
                        {#if user.status == 1}
                          <span class="tag is-small is-success">{tl("Open")}</span>
                        {/if}
                        {#if user.status == 2}
                          <span class="tag is-small is-info">{tl("Closed")}</span>
                        {/if}
                        {#if user.status == 3}
                          <span class="tag is-small is-danger">{tl("Under duress")}</span>
                        {/if}
                        {#if user.status == 4}
                          <span class="tag is-small">{tl("Blocked")}</span>
                        {/if}
                        {#if user.status == 5}
                          <span class="tag is-small is-warning is-light">
                            {tl("REFRESHING")}
                          </span>
                        {/if}
                      </td>
                      <td>
                        <a
                          on:click={async () => {
                            if (await fancyConfirm(tl("This action cannot be undone. Are you sure?"), tl("Delete user"), tl("Delete user"))) removeUser($status.subscription.users.findIndex(u => u.user == user.user && u.service == user.service));
                          }}>
                          {tl("Delete user")}
                        </a>
                        <button
                          class="button is-small is-pulled-right"
                          on:click={() => adminUserModal($status.subscription.users.findIndex(u => u.user == user.user && u.service == user.service))}>
                          {tl("Admin")}
                        </button>
                        <button
                          class="button is-small is-pulled-right gap gap-right"
                          on:click={() => offlineModeModal($status.subscription.users.findIndex(u => u.user == user.user && u.service == user.service))} disabled={user.status == 0 || user.status == 4}>
                          {tl("Offline test")}
                        </button>
                      </td>
                    </tr>
                  {/each}
                </tbody>

              </table>

            </div>
          </div>
        {/if}

      </div>
    </div>

    {#if createUserModalFlag}
      <div class="modal is-active is-fixed-right">
        <div class="modal-background" />

        <div class="modal-content" transition:fade="{{ duration: 200 }}">
          <div class="card">
            <div class="card-heading">
              <div class="level">
                <div class="level-left">
                  <div class="level-item has-text-weight-semibold">{creationDone?newUserName:tl("New user")}</div>
                </div>

                <div class="level-right">
                  <div class="level-item">
                    <button
                      class="delete is-large"
                      on:click={() => {
                        createUserModalFlag = false;
                      }} />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-content is-clearfix">

              {#if !creationDone}
                <div class="field">
                  <label class="label">{tl("User name")}</label>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      bind:value={newUserName}
                      placeholder={tl("User name")} />
                    <p
                      class="help has-text-danger"
                      class:is-invisible={!$status.subscription.users.find(u => u.user == newUserName && u.service == $status.subscription.services[newUserServiceIndex].name)}>
                      {tl("Duplicate user")}
                    </p>
                  </div>
                </div>
                <div class="field">
                  <label class="label">{tl("Service")}</label>
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select bind:value={newUserServiceIndex}>
                        {#each $status.subscription.services as service, i}
                          <option value={i}>{service.name}</option>
                        {/each}
                      </select>
                    </div>
                  </div>
                </div>

       
              {:else} 
              <!-- new user info -->
              <div class="zt-field-wrapper">
                <label>{tl("User name")}</label>
                <p>{newUserName}</p>
              </div>

              <div class="zt-field-wrapper">
                <label>{tl("Service")}</label>
                <p>{$status.subscription.services[newUserServiceIndex].name}</p>
              </div>

              <div class="zt-field-wrapper">
                <label>{tl("Current status")}</label> 
                  <p> 
                  <span class="tag is-small is-warning">{tl("Awaiting enrollment")}</span>
                </p>
                 <p class="help">
                    {tl("User can scan this QR code to enroll their ZofToken")} 
                  </p>
              </div>
              <div class="columns is-baseline">
                  <div class="column is-5">
                    <img class="qr-code" src={qrContent}
                    alt="" />
                  </div>
                  <div class="column">
                    <!-- <a href="" class="has-text-dark">Download QR image</a> -->
                    <a class="a-copy is-small has-text-dark" on:click={() => copyToClipboard(deeplink)}>{tl("Copy deeplink code")}</a>
                  </div>
              </div>


              {/if}
            </div>
            {#if !creationDone}
                <footer class="card-footer">
                  <p class="card-footer-item">
                  
                          <button
                                    class="button is-dark"
                                    class:is-invisible={creationDone}
                                    disabled={$status.subscription.users.find(u => u.user == newUserName && u.service == $status.subscription.services[newUserServiceIndex].name) || newUserName.trim().length == 0}
                                    on:click={createUser}>
                                    {tl("Create user")}
                                  </button>

                  </p>
                  <p class="card-footer-item">
                    <button class="button"  on:click={() => {
                        createUserModalFlag = false;
                      }}>{tl("Cancel")}</button>
                  </p>

                </footer>
            {:else}
              <footer class="card-footer">

                <p class="card-footer-item">
                  <button class="button is-dark"  on:click={() => {
                      createUserModalFlag = false;
                    }}>{tl("Close")}</button>
                </p>

              </footer>
            {/if}
          </div>
        </div>
      </div>
    {/if}

    {#if adminUserModalFlag}
      <div class="modal is-active is-fixed-right">
        <div class="modal-background" />

        <div class="modal-content" transition:fade="{{ duration: 200 }}">
          <div class="card">
            <div class="card-heading">
              <div class="level">
                <div class="level-left">
                  <div class="level-item has-text-weight-semibold">{$status.subscription.users[userIndex].user}</div>
                </div>

                <div class="level-right">
                  <div class="level-item">
                    <button
                      class="delete is-large"
                      on:click={() => {
                        adminUserModalFlag = false;
                      }} />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-content is-clearfix">

              <div class="zt-field-wrapper">
                <label>{tl("User name")}</label>
                <p>{$status.subscription.users[userIndex].user}</p>
              </div>
              <div class="zt-field-wrapper">
                <label>{tl("Service")}</label>
                <p>{$status.subscription.users[userIndex].service}</p>
              </div>
              <div class="zt-field-wrapper">
                <label>{tl("Status")}</label>
                <div class="level">
                  <div class="level-left">
                     <p> 
                    {#if $status.subscription.users[userIndex].status == 0}
                      <span class="tag is-small is-warning">{tl("Awaiting enrollment")}</span>
                    {/if}
                    {#if $status.subscription.users[userIndex].status == 1}
                      <span class="tag is-small is-success">{tl("Open")}</span>
                    {/if}
                    {#if $status.subscription.users[userIndex].status == 2}
                      <span class="tag is-small is-info">{tl("Closed")}</span>
                    {/if}
                    {#if $status.subscription.users[userIndex].status == 3}
                      <span class="tag is-small is-danger">{tl("Under duress")}</span>
                    {/if}
                    {#if $status.subscription.users[userIndex].status == 4}
                      <span class="tag is-small">{tl("Blocked")}</span>
                    {/if}
                  </p>
                  </div>
                  <div class="level-right">
                     <a class="has-text-dark level-item" on:click={() => refreshUserStatusModal(userIndex)}>{tl("Refresh status")}
                        <span class="icon is-large is-clickable is-size-4 level-item">
                          <ion-icon name="refresh-circle"/>
                        </span>
                    </a>
                  </div>
                </div>
               
                <p class="help">
                    {tl("You can update the status with the button above")}
                  </p>
              </div>


              {#if $status.subscription.users[userIndex].status}
                <div class="zt-field-wrapper">
                    <label>{tl("Force status change")}</label>
                  
                </div>
                <div class="buttons">
                <button disabled={$status.subscription.users[userIndex].status == 1}
                    class="button is-rounded is-small"
                    on:click={() => changeUserStatus(1)}>
                    {tl("OPEN")}
                  </button>
                  <button disabled={$status.subscription.users[userIndex].status == 2}
                    class="button is-rounded is-small"
                    on:click={() => changeUserStatus(2)}>
                    {tl("CLOSE")}
                  </button>
                  <button disabled={$status.subscription.users[userIndex].status == 4}
                    class="button is-rounded is-small"
                    on:click={() => changeUserStatus(4)}>
                    {tl("BLOCK")}
                  </button>
                  <button
                    class="button is-rounded is-small"
                     on:click={async () => {
                            if (await fancyConfirm(tl("This action cannot be undone and the user will have to enroll the token again. Are you sure?"), tl("Reset token"), tl("Reset token"))) reEnrollUser();
                          }}>
                    {tl("ENROLL")}
                  </button>
                </div>
              {:else}

                <div class="columns is-baseline">
                  <div class="column is-5">
                    <img class="qr-code" src={$status.subscription.users[userIndex].enrollmentData.qr}
                    alt="" />
                  </div>
                  <div class="column">
                    <!-- <a href="" class="has-text-dark">Download QR image</a> -->
                    <a class="a-copy is-small has-text-dark" on:click={() => copyToClipboard($status.subscription.users[userIndex].enrollmentData.dl)}>{tl("Copy deeplink code")}</a>
                  </div>
                </div>
              {/if}

              <div class="is-divider"></div>
                <a class="has-text-danger" on:click={async () => {
                            if (await fancyConfirm(tl("This action cannot be undone. Are you sure?"), tl("Delete user"), tl("Delete user"))) removeUser(userIndex);
                          }}>
                          {tl("Delete user")}
                        </a>
            </div>
            <footer class="card-footer">
              <p class="card-footer-item">
                <button class="button is-dark"  on:click={() => {
                    adminUserModalFlag = false;
                  }}>{tl("Close")}</button>
              </p>
            </footer>
          </div>
        </div>
      </div>
    {/if}

    {#if offlineModeModalFlag}
      <div class="modal is-active is-fixed-right">
        <div class="modal-background" />

        <div class="modal-content" transition:fade="{{ duration: 200 }}">
          <div class="card">
            <div class="card-heading">
              <div class="level">
                <div class="level-left">
                  <div class="level-item has-text-weight-semibold">{tl("Offline mode test")}</div>
                </div>

                <div class="level-right">
                  <div class="level-item">
                    <button
                      class="delete is-large"
                      on:click={() => {
                        offlineModeModalFlag = false;
                      }} />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-content is-clearfix">
                <p><b>{tl("Step 1")}</b></p>
                <div class="zt-field-wrapper">
                  <label>{tl("Code Size")}</label>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      bind:value={challengeSize} />
                    <p
                      class="help">
                      {tl("Has to be a multiple of 4 between 4 and 32")}
                    </p>
                  </div>
                </div>

                <div class="zt-field-wrapper">
                  <button class="button is-dark"
                  disabled={challengeSize % 4 || challengeSize < 4 || challengeSize > 32}
                  on:click={offlineModeChallenge}>{tl("Get challenge code")}</button>
                </div>

                <br />

                <p><b>{tl("Step 2")}</b></p>
                <div class="zt-field-wrapper">
                  <label>{tl("Challenge Code")}</label>
                  <div class="control has-icons-right" class:is-clickable={userChallenge} on:click={copyToClipboardNotDisabled(userChallenge)}>
                    <input
                      disabled
                      class="input monotype"
                      type="text"
                      bind:value={userChallenge}/>
                      <span class="icon is-small is-right is-clickable" class:has-text-dark={userChallenge}>
                        <ion-icon name="copy-outline"></ion-icon>
                      </span>
                    <p
                      class="help">
                      {tl("This is the code that needs to be sent to the user")}
                    </p>
                  </div>
                </div>

                <div class="zt-field-wrapper">
                  <label>{tl("User Response")}</label>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      bind:value={userResponse} disabled={!userChallenge}/>
                    <p
                      class="help">
                      {tl("This is the code that the user gets in the ZofToken app")}
                    </p>
                  </div>
                </div>

                <div class="zt-field-wrapper">
                  <button class="button is-dark"
                  disabled={!userResponse || userResponse.length != challengeSize}
                  on:click={offlineModeResponse}>{tl("Authenticate")}</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    {/if}


  </div>
</section>
